// extracted by mini-css-extract-plugin
export default {"confirm-save-report-popup":"ConfirmSaveReportPopup_confirm-save-report-popup__6vjgS"};